import React, { Suspense } from 'react';
import logo from './logo.svg';
import './App.css';
import Dashboard from './ui/Dashboard';
import { Route, Router, Routes, BrowserRouter } from 'react-router-dom';
interface AppProps {
    url: string
}
function App({ url }: AppProps) {
  
  return (

    <BrowserRouter>
      <Routes>
        <Route path="*" element={<Dashboard url={url} />} />
      </Routes>
    </BrowserRouter>

  );

}

export default App;
